const scrollToTopWrp = document.querySelector('.scroll-to-top');
const scrollToTopBtn = scrollToTopWrp?.querySelector('.scrollToTop');

let scrollAnimationFrame = null;
let isAutoScrolling = false;

function getScrollTop() {
  return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function showScrollToTop() {
  if (getScrollTop() > (window.innerHeight / 2)) {
    scrollToTopWrp?.classList.add('active');
  } else {
    scrollToTopWrp?.classList.remove('active');
  }
}

// Bound function for easy removal
const scrollHandler = () => {
  showScrollToTop();
};

if (scrollToTopWrp) {
  showScrollToTop();
  window.addEventListener('scroll', scrollHandler);
}

function stopAutoScroll() {
  if (scrollAnimationFrame) {
    cancelAnimationFrame(scrollAnimationFrame);
    scrollAnimationFrame = null;
  }

  if (isAutoScrolling) {
    removeUserInterruptionListeners();
  }

  isAutoScrolling = false;
}

function handleUserInterruption() {
  stopAutoScroll();
}

function addUserInterruptionListeners() {
  window.addEventListener('wheel', handleUserInterruption, { passive: true });
  window.addEventListener('touchstart', handleUserInterruption, { passive: true });
  window.addEventListener('touchmove', handleUserInterruption, { passive: true });
  window.addEventListener('pointerdown', handleUserInterruption, { passive: true });
  window.addEventListener('keydown', handleUserInterruption);
}

function removeUserInterruptionListeners() {
  window.removeEventListener('wheel', handleUserInterruption);
  window.removeEventListener('touchstart', handleUserInterruption);
  window.removeEventListener('touchmove', handleUserInterruption);
  window.removeEventListener('pointerdown', handleUserInterruption);
  window.removeEventListener('keydown', handleUserInterruption);
}

function stepScrollToTop() {
  if (!isAutoScrolling) {
    return;
  }

  const position = getScrollTop();

  if (position) {
    window.scrollBy(0, -Math.max(1, Math.floor(position / 10)));
    scrollAnimationFrame = requestAnimationFrame(stepScrollToTop);
  } else {
    stopAutoScroll();
  }
}

function scrollToTop() {
  stopAutoScroll();

  const position = getScrollTop();
  if (!position) {
    return;
  }

  isAutoScrolling = true;
  addUserInterruptionListeners();
  scrollAnimationFrame = requestAnimationFrame(stepScrollToTop);
}

if (scrollToTopBtn) {
  scrollToTopBtn.addEventListener('click', () => {
    scrollToTop();
  });
}

// Cleanup function for potential use
window.cleanupScrollToTop = function() {
  stopAutoScroll();
  window.removeEventListener('scroll', scrollHandler);
};